import './App.css';
import {logMessage} from './components/utils.js';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect, Suspense, lazy } from 'react';
import { getUserDetail,useLocalStorageListener  } from './hooks/handleUserLocalStorage';

import api from './apis';
import { useLocation } from 'react-router-dom';
//import 'antd/dist/antd.css';
import { useGlobalVariable } from './context/GlobalVariableProvider';
import 'antd/dist/antd.min.css';

// import global css
import './components/asset/sb-admin-2/scss/sb-admin-2.scss';
import './components/asset/styles/layout-style.css';
import './components/asset/bootstrap-icons/bootstrap-icons.css';
import './components/asset/styles/main-style.css';
import './components/asset/font-awesome/css/all.css';
import './components/asset/style.css';

//public path
import Missing from './components/pages/public/Missing';
import Unauthorized from './components/pages/public/Unauthorized';
import PgLanding from './components/pages/public/PgLanding';
import PgLogin from './components/pages/public/PgLogin';

//public demo 

import UtradeLogin from './components/pages/public/demoPage/Utrade/UtradeLogin'; //utrade login

//public landing page
//navigation
import MobileNav from './components/General/MobileNav';
import Nav from './components/pages/public/Landing/components/General/Nav';
import Footer from './components/pages/public/Landing/components/General/Footer';

//protected path
import FundingDeposit from './components/pages/protected/FundingDeposit';
import FundingWithdrawal from './components/pages/protected/FundingWithdrawal';
import FundingSettlement from './components/pages/protected/FundingSettlement';
import FundingHistory from './components/pages/protected/FundingHistory';


import Estatement from './components/pages/protected/Estatement';

import Empty from './components/pages/protected/Empty';

// /import CorporateAction from './components/pages/protected/CorporateAction';

import ResearchReports from './components/pages/protected/ResearchReports';
import Announcement from './components/pages/protected/Announcement';
import AnnouncementCopy from './components/pages/protected/Announcement - Copy';

import DisplayTempFile from './components/pages/protected/DisplayTempFile';
import DisplayFile from './components/pages/protected/DisplayFile';
import DisplayEstatementFile from './components/pages/protected/DisplayEstatementFile';

//import ChangePassword from './components/pages/protected/ChangePassword';

// layout container
import LayoutContainer from './components/layouts/LayoutContainer';

//eform
// import EFormDataCorrection from './components/pages/protected/EFormDataCorrection';
// import EFormCTACredit from './components/pages/protected/EFormCTACredit';

//forget password
import UpdateForgetPassword from './components/pages/public/UpdateForgetPassword';

//use global loading screen
import { LoadingProvider, useLoading } from './context/LoadingContext';

import WithAxios from './context/WithAxios';
import WithCheckLoginStatus from './context/WithCheckLoginStatus';

//protected path
import Dashboard from './components/pages/protected/TradingPlatform';
import Portfolio from './components/pages/protected/Portfolio';
import TradingPlatform from './components/pages/protected/TradingPlatform';
// import CustomerProfile from './components/pages/protected/CustomerProfile';

import OutstandingPurchase from './components/pages/protected/OutstandingPurchase';
import OutstandingSales from './components/pages/protected/OutstandingSales';
import AccountSummary from './components/pages/protected/AccountSummary';
import Contra from './components/pages/protected/Contra';
//import ContractInformation from './components/pages/protected/ContractInformation';
import Contract from './components/pages/protected/Contract';
import TradeHistory from './components/pages/protected/TradeHistory';

import DueForForceSelling from './components/pages/protected/DueForForceSelling';
import DueForSettlement from './components/pages/protected/DueForSettlement';
import RemainingPurchaseContracts from './components/pages/protected/RemainingPurchaseContracts';
import SalesProceedDue from './components/pages/protected/SalesProceedDue';
import RemainingSalesContract from './components/pages/protected/RemainingSalesContract';
import Others from './components/pages/protected/Others';

import sidebarSource from './components/navigation/nav-config';
import ComingSoon from './components/pages/protected/ComingSoon';
import Tools from './components/pages/protected/Tools';
import UserGuide from './components/pages/protected/UserGuide';
import UtradeRegisterAccount from './components/pages/public/demoPage/Utrade/UtradeRegisterAccount';
import UtradeRegisterEdocument from './components/pages/public/demoPage/Utrade/UtradeRegisterEDocument';
import UtradeForgotPassword from './components/pages/public/demoPage/Utrade/UtradeForgotPassword';
import UtradeForgotUserID from './components/pages/public/demoPage/Utrade/UtradeForgotUserID';

import UtradeAgreement from './components/pages/public/demoPage/Utrade/UtradeAgreement';
import Accessdenied from './components/pages/protected/Accessdenied';

import PgActivate from './components/pages/public/PgActivate';

//home
// import LandingPage from './components/pages/public/Landing/LandingPage';
// import PgHomePage from './components/pages/public/Landing/components/Home/PgHomePage';

// import Bos from './components/pages/public/Landing/components/Product/Bos';
// import AboutPage from './components/pages/public/Landing/components/About/AboutPage';
// import Contact from './components/pages/public/Landing/components/Contact/Contact';


const LandingPage = lazy(() => import('./components/pages/public/Landing/LandingPage'));
const PgHomePage = lazy(() => import('./components/pages/public/Landing/components/Home/PgHomePage'));
const Tds = lazy(() => import('./components/pages/public/Landing/components/Product/Tds'));
const Bos = lazy(() => import('./components/pages/public/Landing/components/Product/Bos'));
const AboutPage = lazy(() => import('./components/pages/public/Landing/components/About/AboutPage'));
const Contact = lazy(() => import('./components/pages/public/Landing/components/Contact/Contact'));



//protected path
// const Contra = lazy(() => import('./components/pages/protected/Contra'));
// const Contract = lazy(() => import('./components/pages/protected/Contract'));
// const AccountSummary = lazy(() => import('./components/pages/protected/AccountSummary'));
// const TradeHistory = lazy(() => import('./components/pages/protected/TradeHistory'));

// const Dashboard = lazy(() => import('./components/pages/protected/Dashboard'));
// const Portfolio = lazy(() => import('./components/pages/protected/Portfolio'));
// const TradingPlatform = lazy(() => import('./components/pages/protected/TradingPlatform'));
// const CustomerProfile = lazy(() => import('./components/pages/protected/CustomerProfile'));
// const AccountSummary = lazy(() => import('./components/pages/protected/AccountSummary'));
// const OutstandingPurchase = lazy(() => import('./components/pages/protected/OutstandingPurchase'));
// const OutstandingSales = lazy(() => import('./components/pages/protected/OutstandingSales'));
// const Contra = lazy(() => import('./components/pages/protected/Contra'));
// const ContractInformation = lazy(() => import('./components/pages/protected/ContractInformation'));


function App() {
    const { setLoading } = useLoading();
    const [doneInitial, setDoneInitial] = useState(false);


    const [doneFirstTimeEnterPage, setDoneFirstTimeEnterPage] = useState(false);

    const location = useLocation();
 
    useEffect(() => {
        //logined
        let userDetail = getUserDetail();
        if (userDetail?.user) {
            axiosHearBeat();
     
        } else {
            setDoneInitial(true);
        }
        handleDoneFirstTimeEnterPage();
    }, []);

    const handleDoneFirstTimeEnterPage = ()=>{
        if(!doneFirstTimeEnterPage){
            setDoneFirstTimeEnterPage(true);
            let currentPage = location.pathname;

            //check page path
            let currentPageProps = getCurrentPageConfig(currentPage);
            if(currentPageProps){
                let targetName = currentPageProps.targetName;
                if(targetName){
                    window.name = targetName
                }
    
                logMessage("currentPage ",currentPage,window.name);
            }
          
            
        }

    }

    const getCurrentPageConfig = ( currentPage: String) => {
        let data = sidebarSource;
        let currentPageProps = null;
        for (var i = 0; i < data.length; i++) {
            let row = data[i];
            if (row.url == currentPage) {
                currentPageProps = row;
                break;
            }

            if (row.subMenu && row.subMenu.length > 0) {
                for (var z = 0; z < row.subMenu.length; z++) {
                    let innerRow = row.subMenu[z];
                    if (innerRow.url == currentPage) {
                        currentPageProps = innerRow;
                        break;
                    }
                }
            }
        }
        return currentPageProps;
    }

    // useEffect(() => {
    //     //check if logined

    //     var body = document.querySelector('body');
    //     if (cookies.user) {
    //         // console.log('logined');
    //         // console.log(cookies.user);
    //         body?.style.setProperty('overflow', 'hidden');
    //     } else {
    //         //landing scrollbar
    //         body?.style.setProperty('overflow', 'initial');
    //     }
    // }, [cookies]);

    useLocalStorageListener((newUserValue) => {
        // console.log('newUserValue', newUserValue);
        var body = document.querySelector('body');
        if (newUserValue) {
          // console.log('logined');
            // console.log(cookies.user);
            body?.style.setProperty('overflow', 'hidden');
        } else {
           //landing scrollbar
           body?.style.setProperty('overflow', 'initial');
        }
    });

    useEffect(() => {
        //landing page animation
        window.AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
    }, []);

    const axiosHearBeat = async () => {
        await api.heartbeat();
        setDoneInitial(true);
    };
  
    //if got user in cookis then show protected route, else show landing page / login page if login failed
    const SetRoutePaths = getUserDetail()?.user ? ProtectedRoute() : PublicRoute(); 
    
    return (
        <LoadingProvider>
            <WithAxios>
                <WithCheckLoginStatus>
                    <Suspense fallback={<div></div>}>
                        <Routes>{doneInitial ? SetRoutePaths : <></>}</Routes>
                    </Suspense>
                </WithCheckLoginStatus>
            </WithAxios>
        </LoadingProvider>
    );
}

const ProtectedRoute = () => {
    return (
        <>
        
                <Route path="/" element={<LayoutContainer />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/trading-platform" element={<TradingPlatform />} />

                    <Route path="/trade-history" element={<TradeHistory />} />

                    {/* <Route path="/customer-profile" element={<CustomerProfile />} /> */}
                    <Route path="/account-summary" element={<AccountSummary />} />
                    <Route
                        path="/outstanding-purchase"
                        element={<OutstandingPurchase />}
                    />
                    <Route
                        path="/outstanding-sales"
                        element={<OutstandingSales />}
                    />
                    <Route path="/contra" element={<Contra />} />
                    <Route path="/contract" element={<Contract />} />
                    <Route path="/due-for-force-selling" element={<DueForForceSelling />} />
                    <Route path="/due-for-settlement" element={<DueForSettlement />} />
                    <Route path="/remaining-purchase-contracts" element={<RemainingPurchaseContracts />} />
                    <Route path="/sales-proceed-due" element={<SalesProceedDue />} />
                    <Route path="/remaining-sales-contracts" element={<RemainingSalesContract />} />

                    <Route path="/statement-of-account" element={<Estatement />} />
                    <Route path="/econtra" element={<Estatement />} />
                    <Route path="/esetoff" element={<Estatement />} />
                    <Route path="/epayment-voucher" element={<Estatement />} />
                    <Route path="/ecredit-debit-note" element={<Estatement />} />
                    <Route path="/eforeign-share-statement" element={<Estatement />} />
                    <Route path="/payment-receipt" element={<Estatement />} />
                    <Route path="/cancellation-of-or" element={<Estatement />} />
                    <Route path="/cancellation-of-pv" element={<Estatement />} />
          
                  
                    <Route path="/others" element={<Others />} />
                  
                    
                    {/* <Route
                        path="/contract-information"
                        element={<ContractInformation />}
                    /> */}


                    <Route path="/funding-deposit" element={<FundingDeposit />} />
                    <Route
                        path="/funding-withdrawal"
                        element={<FundingWithdrawal />}
                    />
                    <Route
                        path="/funding-settlement"
                        element={<FundingSettlement />}
                    />
                    <Route path="/funding-history" element={<FundingHistory />} />

                    <Route path="/eStatement" element={<Estatement />} />

                    {/* <Route path="/corporate-action" element={<CorporateAction />} /> */}

                    <Route path="/research-reports" element={<ResearchReports />} />

                    <Route path="/Announcement" element={<AnnouncementCopy />} />
                    <Route path="/AnnouncementCopy" element={<AnnouncementCopy />} />
                    
                    {/* <Route
                        path="/data-correction-request-form"
                        element={<EFormDataCorrection />}
                    />
                    <Route path="/cta-ecredit-form" element={<EFormCTACredit />} /> */}
                    <Route
                        path="reset_password"
                        element={<UpdateForgetPassword />}
                    />
                    {/* <Route
                        path="/change-password"
                        element={<ChangePassword />}
                    /> */}
                    <Route path="/chart-genie" element={<Tools page={"/api/tool/chart-genie"}/>} />
                    <Route path="/share-xplorer" element={<Tools page={"/api/tool/share-xplorer"}/>} />
                    <Route path="/stock-screener" element={<Tools page={"/api/tool/stock-screener"}/>} />
                    <Route path="/research-video" element={<Tools page={"/api/tool/research-video"}/>} />
               
                    <Route path="/coming-soon" element={<ComingSoon />} />

                    <Route path="/user-guide" element={<UserGuide />} />

                    <Route path="/accessdenied" element={<Accessdenied />} />

                    <Route path="/empty" element={<Empty />} />
                    
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
                <Route path="/file/:file" element={<DisplayTempFile />} />
                <Route path="/file/:a_id/:file" element={<DisplayFile />} />
                <Route path="/file/estatement/:es_aid/:es_id" element={<DisplayEstatementFile />} />
   
                <Route
                path="test"
                element={<Contra />}
                />

               
        </>
    );
};

const PublicRoute = () => {
    return (
        // <Route path="/">
        //     {/* public routes */}
        //     <Route path="/" element={<PgLanding />} />
        //     {/* } /> */}

        //     <Route path="unauthorized" element={<Unauthorized />} />
        //     {/* <Route path="/" element={<PgLanding />} /> */}
        //     <Route path="login" element={<PgLogin />} />
        //     <Route path="reset_password" element={<UpdateForgetPassword />} />

        //     {/* catch all */}
        //     <Route path="*" element={<Navigate to="/login" replace />} />
        // </Route>

        <>
             <Route path="/" element={<LandingPage />}>
                {/* landing page  */}
                {/* public routes */}
                <Route index element={<PgHomePage />} />
                <Route path="/home" element={<PgHomePage />} />
                <Route path="/tds" element={<Tds />} />
                <Route path="/bos" element={<Bos />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<Contact />} />

                {/* } /> */}
                {/* End landing page */}
            </Route>
            <Route path="login" element={<PgLogin />}></Route>
            <Route path="UtradeLogin" element={<UtradeLogin />}></Route>
            <Route path="register-account" element={<UtradeRegisterAccount />}></Route>
            <Route path="first-time-login" element={<UtradeRegisterAccount firstTimeLogin={true}/>}></Route>
            <Route path="register-edoc" element={<UtradeRegisterEdocument />}></Route>

            <Route path="forget-password" element={<UtradeForgotPassword />}></Route>
            <Route path="forget-userid" element={<UtradeForgotUserID />}></Route>
           
            <Route path="agreement" element={<UtradeAgreement />}></Route>
            <Route path="/accessdenied" element={<Accessdenied />} />
            <Route path="unauthorized" element={<Unauthorized />} />
            <Route path="/activation" element={<PgActivate/>} />
            
            {/* <Route path="/" element={<PgLanding />} /> */}
            {/* <Route
                                path="reset_password"
                                element={<UpdateForgetPassword />}
                            /> */}

           
            {/* catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </>
    );
};

export default App;
